module.exports = __webpack_public_path__ + "img/management.e8d0c9dc.png";